import React from "react";
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import { Moon, Sun } from "lucide-react";
import styles from "./ToggleGroup.module.css";

interface ToggleProps {
  value: string;
  onValueChange: (value: string) => void;
}

const Toggle: React.FC<ToggleProps> = ({ onValueChange, value }) => {
  return (
    <ToggleGroupPrimitive.Root
      className={styles.toggleGroup}
      type="single"
      value={value}
      onValueChange={onValueChange}
    >
      <ToggleGroupPrimitive.Item value="light-theme" className={styles.toggleItem}>
        <Sun size={20} />
      </ToggleGroupPrimitive.Item>
      <ToggleGroupPrimitive.Item value="dark-theme" className={styles.toggleItem}>
        <Moon size={20} />
      </ToggleGroupPrimitive.Item>
    </ToggleGroupPrimitive.Root>
  );
};

export default Toggle;
